import { useTranslation } from "react-i18next";
import CheckIcon from "../../../icons/checkIcon";

const Stepper = ({ currentStep }) => {
  const { t } = useTranslation();
  const steps = [
    { id: 1, title: t("companyInfo") },
    { id: 2, title: t("legalRepresentative") },
    { id: 3, title: t("servicesProvided") },
    { id: 4, title: t("requiredDocuments") },
  ];

  return (
    <div className="flex items-center justify-between">
      {steps.map((step, index) => (
        <div key={step.id} className="flex flex-col items-center flex-1">
          <div
            className={`flex items-center justify-center w-8 h-8 rounded-full border-2 ${
              currentStep > index + 1
                ? "bg-green-500 border-green-500 text-white"
                : currentStep === index + 1
                ? "bg-blue-500 border-blue-500 text-white"
                : "bg-gray-400 border-gray-400 text-white"
            }`}
          >
            {currentStep > index + 1 ? <CheckIcon fill={"white"} /> : index + 1}
          </div>
          <span className="mt-2 text-sm">{step.title}</span>
        </div>
      ))}
    </div>
  );
};

export default Stepper;
